export default __webpack_public_path__ + "static/media/proclamationBanner.e32172d7.png";